import React from 'react';
import { i18n } from 'config/locales';
import Field from 'components/Form/Field';

const HandlingProtectedInformationIntro = function () {
  return (
    <div>
      <h1 className="section-header">{i18n.t('legal.pvq.protectedInformation.heading.title')}</h1>
      <p>{i18n.m('legal.pvq.protectedInformation.para.intro0')}</p>
      <Field optional className="no-margin-bottom">
        <p>For this section:</p>
        {i18n.m('legal.pvq.protectedInformation.para.intro1')}
        {i18n.m('legal.pvq.protectedInformation.para.intro2')}
        {i18n.m('legal.pvq.protectedInformation.para.intro3')}
        {i18n.m('legal.pvq.protectedInformation.para.intro4')}
      </Field>
    </div>
  );
};

export default HandlingProtectedInformationIntro;
